import React from 'react';
import { useSelector } from 'react-redux';

import * as GoalsSelectors from 'Shared/selectors/Goals.selectors';

import { User } from 'Shared/constants/types';

import UserGoalsContainer from 'Shared/components/Goals/UserGoalsContainer';

type Props = {
  user: User;
  isViewingComplete?: boolean;
  workspaceSlug: string;
};

const GroupWorkspaceUserGoals = ({ user, isViewingComplete, workspaceSlug }: Props) => {
  const goals = useSelector(state =>
    GoalsSelectors.getGoalsByUserIdAndCompleteAndWorkspace(state, {
      userId: user.id,
      complete: isViewingComplete,
      workspaceSlug,
    })
  )
    .valueSeq()
    .toJS();

  return (
    <div className="WorkspaceUserGoals">
      <UserGoalsContainer user={user} goals={goals} />
    </div>
  );
};

export default GroupWorkspaceUserGoals;
